import React, { } from "react";
import { MdCheckCircle } from "react-icons/md";
import useIntersectionObserver from "./home-animation";
export default function HomePortal() {
    const [sectionRef, isVisible] = useIntersectionObserver({ threshold: 0.1 });
    return (
        <div className="home-portal">
            <div className="outer-container">
            <div className={`outer-portal ${isVisible ?'animate__fadeInDown' :''}`} style={{ animationDuration: '1.25s' }} ref={sectionRef}>
                <div className="home-portal-left">
                    <div className="home-portal-div">
                        <MdCheckCircle className="home-portal-div-svg"/>
                        <div className="home-portal-content">
                        <h3 className="home-portal-div-head">Talent Acquisition</h3>
                        <p className="main-para">Connecting top talent with leading employers to drive success.</p>
                        </div>
                    </div>
                    <div className="home-portal-div">
                        <MdCheckCircle className="home-portal-div-svg"/>
                        <div className="home-portal-content">
                        <h3 className="home-portal-div-head">Job Portal</h3>
                        <p className="main-para">Your gateway to discovering and applying for the perfect job opportunities.</p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
}
